import app from 'flarum/common/app';

app.initializers.add('tf/sso', () => {
});
